module.exports = __webpack_public_path__ + "media/assets/images/blog/pexels-cottonbro-agile2-small-a5670a540dc0e98c85de0707aaef7a20.jpg";